import React from "react";


const Assetsrecommendations = () => {
  document.title = "Assets-recommendations";

  return (
    <React.Fragment>
      <div className="page-content">

        <h1>Assets-recommendations</h1>
        
      </div>
    </React.Fragment>
  );
};

export default Assetsrecommendations;
